import { CropperImageProp } from '@/types/cropper'

const CROP_CHANGE_THRESHOLD = 2
const CROP_KEYS = ['crop_y', 'crop_x', 'crop_w', 'crop_h'] as const

export const hasChangesInImageTransform = (
  oldCropImage: CropperImageProp,
  newCropImage: CropperImageProp
) => {
  if (oldCropImage.transform.image_id !== newCropImage.transform.image_id) {
    return true
  }

  return CROP_KEYS.some(
    (key) =>
      Math.abs(
        (oldCropImage.transform[key] || 0) - (newCropImage.transform[key] || 0)
      ) >= CROP_CHANGE_THRESHOLD
  )
}
